function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t.return || t.return();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _taggedTemplateLiteral(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(t)
    }
  }));
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
import "../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";
import { html as a } from "../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";
import "../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";
import _ from "../../../packages/web-components/src/index.slds.scss.js";
import { customElement as f } from "../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/decorators/custom-element.js";
import { property as h } from "../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/decorators/property.js";
import { state as v } from "../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/decorators/state.js";
import { NjcCombobox as b } from "./combobox.js";
import { generateRandomId as g } from "../../../utils/string-utils.js";
import "../../input/slds/input-label/input-label.slds.js";
import "../../input/slds/input-error/input-error.slds.js";
import { KEY_CONSTANTS as p } from "../../../consts/key-constants.js";
import { ref as u } from "../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/directives/ref.js";
import { handleDataTestid as l } from "../../../utils/datatestid-utils.js";
import "../combobox-item/combobox-item.slds.js";
import "../../icon/slds/icon.slds.js";
import { unsafeCSS as $, css as w } from "../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/css-tag.js";
var y = Object.defineProperty,
  T = Object.getOwnPropertyDescriptor,
  r = function r(e, t, n, i) {
    for (var s = i > 1 ? void 0 : i ? T(t, n) : t, d = e.length - 1, c; d >= 0; d--) (c = e[d]) && (s = (i ? c(t, n, s) : c(s)) || s);
    return i && s && y(t, n, s), s;
  },
  m = function (e) {
    return e.FIVE = "5", e.SEVEN = "7", e.TEN = "10", e.NOSCROLL = "", e;
  }(m || {});
var o = /*#__PURE__*/function (_b) {
  function o() {
    var _this;
    _classCallCheck(this, o);
    _this = _callSuper(this, o, arguments), _this.autocomplete = !1, _this.clearAssistiveText = "Clear", _this.comboboxAriaLabel = "Dropdown Items", _this.dropdownLength = "10", _this._searchValue = "", _this._generatedId = g();
    return _this;
  }
  _inherits(o, _b);
  return _createClass(o, [{
    key: "updated",
    value: function updated() {
      this.updateDataTestids();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      return a(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n            <div class=\"slds-form-element", "\" @focusout=", ">\n                <nsc-input-label\n                    .required=\"", "\"\n                    for=\"combobox-id-", "\"\n                    label-id=\"combobox-label-", "\"\n                    label=\"", "\"\n                ></nsc-input-label>\n                <div class=\"slds-form-element__control\">\n                    <div class=\"slds-combobox_container\">\n                        <div\n                            class=\"slds-combobox slds-dropdown-trigger slds-dropdown-trigger_click ", "\"\n                        >\n                            ", "\n                            <div\n                                id=\"listbox-id-", "\"\n                                class=\"slds-dropdown slds-dropdown_fluid ", "\"\n                                aria-label=\"", "\"\n                                tabindex=\"-1\"\n                                aria-busy=\"false\"\n                                role=\"listbox\"\n                            >\n                                <ul class=\"slds-listbox slds-listbox_vertical\" role=\"presentation\">\n                                    ", "\n                                    <slot></slot>\n                                </ul>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                ", "\n            </div>\n        "])), this.valid ? "" : " slds-has-error", this._topLevelFocusOut, this.required, this._generatedId, this._generatedId, this.label, this.open ? "slds-is-open" : "", this.autocomplete ? this.autocompleteMarkup : this.dropdownTriggerMarkup, this._generatedId, this.dropdownLengthClass, this.comboboxAriaLabel, this._filteredOptions.map(function (e) {
        return a(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n                                            <nsc-combobox-item\n                                                .searchValue=\"", "\"\n                                                label=\"", "\"\n                                                value=\"", "\"\n                                                @change=", "\n                                                .selectedValue=\"", "\"\n                                            ></nsc-combobox-item>\n                                        "])), _this2._searchValue, e.label, e.value, function () {
          return _this2.selectOption(e);
        }, _this2.value);
      }), this.displayedErrorText ? a(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["<nsc-input-error>", "</nsc-input-error>"])), this.displayedErrorText) : null);
    }
  }, {
    key: "dropdownLengthClass",
    get: function get() {
      return this.dropdownLength != "" ? "slds-dropdown_length-".concat(this.dropdownLength) : "";
    }
  }, {
    key: "optionLabel",
    get: function get() {
      var _this$options$find$la,
        _this$options$find,
        _this3 = this;
      return (_this$options$find$la = (_this$options$find = this.options.find(function (e) {
        return e.value === _this3.value;
      })) === null || _this$options$find === void 0 ? void 0 : _this$options$find.label) !== null && _this$options$find$la !== void 0 ? _this$options$find$la : "";
    }
  }, {
    key: "dropdownTriggerMarkup",
    get: function get() {
      return a(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n            <div class=\"slds-combobox__form-element slds-input-has-icon slds-input-has-icon_right\" role=\"none\">\n                <div\n                    role=\"combobox\"\n                    ", "\n                    @keydown=", "\n                    tabindex=\"0\"\n                    class=\"", "\"\n                    aria-labelledby=\"combobox-label-", "\"\n                    id=\"combobox-id-", "-selected-value\"\n                    aria-controls=\"listbox-id-", "\"\n                    aria-expanded=\"", "\"\n                    aria-haspopup=\"listbox\"\n                    @click=", "\n                >\n                    <span class=\"slds-truncate\"> ", " </span>\n                </div>\n                <span class=\"slds-icon_container slds-icon-utility-down slds-input__icon slds-input__icon_right\">\n                    <nsc-icon name=\"down\" size=\"x-small\" svg-classes=\"slds-icon-text-default\"></nsc-icon>\n                </span>\n            </div>\n        "])), u(this._comboboxRef), this.handleKeyDown, this._fauxInputClasses, this._generatedId, this._generatedId, this._generatedId, this.open, this.handleDropdownClick, this.optionLabel || this.placeholder);
    }
  }, {
    key: "_fauxInputClasses",
    get: function get() {
      return "slds-input_faux slds-combobox__input ".concat(this.value ? "slds-combobox__input-value" : "");
    }
  }, {
    key: "handleDropdownClick",
    value: function handleDropdownClick() {
      this.open = !this.open;
    }
  }, {
    key: "autocompleteMarkup",
    get: function get() {
      return this.value ? a(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n                <div role=\"combobox\"\n                     tabindex=\"0\"\n                     class=\"slds-input_faux slds-combobox__input slds-combobox__input-value\"\n                     aria-labelledby=\"combobox-label-", "\"\n                     aria-controls=\"listbox-id-", "\"\n                     aria-expanded=\"", "\"\n                     aria-haspopup=\"listbox\"\n                >\n                    <span class=\"slds-truncate\">", "</span>\n                </div>\n                <button class=\"slds-button slds-button_icon slds-input__icon slds-input__icon_right clear-icon\" title=\"", "\" @click=\"", "\">\n                    <nsc-icon name=\"close\" size=\"x-small\" svg-classes=\"slds-icon-text-default\"></nsc-icon>\n                    <span class=\"slds-assistive-text\">", "</span>\n                </button>\n            "])), this._generatedId, this._generatedId, this.open, this.optionLabel, this.clearAssistiveText, this.clearValue, this.clearAssistiveText) : a(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n            <div class=\"slds-combobox__form-element slds-input-has-icon slds-input-has-icon_right\" role=\"none\">\n                <input\n                    ", "\n                    type=\"text\"\n                    class=\"slds-input slds-combobox__input\"\n                    id=\"combobox-id-", "\"\n                    aria-labelledby=\"combobox-label-", "\"\n                    aria-autocomplete=\"list\"\n                    aria-expanded=\"", "\"\n                    aria-controls=\"listbox-id-", "\"\n                    @keydown=", "\n                    aria-haspopup=\"listbox\"\n                    autocomplete=\"off\"\n                    tabindex=\"0\"\n                    role=\"combobox\"\n                    placeholder=\"", "\"\n                    value=", "\n                    @click=", "\n                    @input=", "\n                />\n                <span class=\"slds-icon_container slds-input__icon slds-input__icon_right\">\n                    <nsc-icon name=\"search\" size=\"x-small\" svg-classes=\"slds-icon-text-default\"></nsc-icon>\n                </span>\n            </div>\n        "])), u(this._comboboxRef), this._generatedId, this._generatedId, this.open, this._generatedId, this.handleKeyDown, this.placeholder, this.value, this.handleDropdownClick, this._handleAutocompleteInput);
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(e) {
      var _this$shadowRoot;
      switch (e.key) {
        case p.DOWN:
          this.handleArrowDown(), e.preventDefault();
          break;
        case p.UP:
          this.handleArrowUp(), e.preventDefault();
          break;
        case p.ENTER:
          var t = (_this$shadowRoot = this.shadowRoot) === null || _this$shadowRoot === void 0 ? void 0 : _this$shadowRoot.querySelector(".slds-has-focus");
          t ? t.click() : this.open = !this.open, e.preventDefault();
          break;
        case p.ESCAPE:
          this.open && e.stopPropagation(), this.open = !1, this.clearFocusClassFromOptions(), e.preventDefault();
          break;
      }
    }
  }, {
    key: "_topLevelFocusOut",
    value: function _topLevelFocusOut(e) {
      e.currentTarget && e.relatedTarget && e.currentTarget.contains(e.relatedTarget) || ((this.required || this._searchValue) && !this.value ? (this.valid = !1, this.displayedErrorText = this.requiredErrorText) : (this.valid = !0, this.displayedErrorText = ""), this.open = !1, this.clearFocusClassFromOptions());
    }
  }, {
    key: "clearFocusClassFromOptions",
    value: function clearFocusClassFromOptions() {
      var _this$shadowRoot2;
      ((_this$shadowRoot2 = this.shadowRoot) === null || _this$shadowRoot2 === void 0 ? void 0 : _this$shadowRoot2.querySelectorAll('[role="option"]')).forEach(function (t) {
        return t.classList.remove("slds-has-focus");
      });
    }
  }, {
    key: "clearValue",
    value: function clearValue() {
      var _this4 = this;
      this.value = "", this._searchValue = "", this.dispatchEvent(new CustomEvent("change", {
        detail: void 0,
        bubbles: !0
      })), setTimeout(function () {
        var _this4$shadowRoot;
        (_this4$shadowRoot = _this4.shadowRoot) === null || _this4$shadowRoot === void 0 || (_this4$shadowRoot = _this4$shadowRoot.getElementById("combobox-id-".concat(_this4._generatedId))) === null || _this4$shadowRoot === void 0 || _this4$shadowRoot.focus();
      });
    }
  }, {
    key: "_handleAutocompleteInput",
    value: function _handleAutocompleteInput(e) {
      var _e$target$value, _e$target;
      this.open || (this.open = !0), this._searchValue = (_e$target$value = e === null || e === void 0 || (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.value) !== null && _e$target$value !== void 0 ? _e$target$value : "";
    }
  }, {
    key: "_filteredOptions",
    get: function get() {
      var _this5 = this;
      return this._searchValue ? this.options.filter(function (e) {
        return e.label.toLowerCase().includes(_this5._searchValue.toLowerCase());
      }) : this.options;
    }
  }, {
    key: "updateDataTestids",
    value: function updateDataTestids() {
      var _this$shadowRoot3, _this$shadowRoot4, _this$shadowRoot5, _this$shadowRoot6, _this$shadowRoot7, _this$shadowRoot8;
      var e = (_this$shadowRoot3 = this.shadowRoot) === null || _this$shadowRoot3 === void 0 ? void 0 : _this$shadowRoot3.querySelector('[role="combobox"]');
      l(e, this.dataTestid, "combobox");
      var t = (_this$shadowRoot4 = this.shadowRoot) === null || _this$shadowRoot4 === void 0 ? void 0 : _this$shadowRoot4.querySelector('[role="listbox"]');
      l(t, this.dataTestid, "listbox");
      var n = (_this$shadowRoot5 = this.shadowRoot) === null || _this$shadowRoot5 === void 0 ? void 0 : _this$shadowRoot5.querySelector('button[title="Clear"]');
      l(n, this.dataTestid, "clear-button");
      var i = (_this$shadowRoot6 = this.shadowRoot) === null || _this$shadowRoot6 === void 0 ? void 0 : _this$shadowRoot6.querySelector("nsc-input-label");
      l(i, this.dataTestid, "label");
      var s = (_this$shadowRoot7 = this.shadowRoot) === null || _this$shadowRoot7 === void 0 ? void 0 : _this$shadowRoot7.querySelector("nsc-input-error");
      l(s, this.dataTestid, "error");
      var d = (_this$shadowRoot8 = this.shadowRoot) === null || _this$shadowRoot8 === void 0 ? void 0 : _this$shadowRoot8.querySelectorAll("nsc-combobox-item");
      var _iterator = _createForOfIteratorHelper(d.entries()),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _ref = _step.value;
          var _ref2 = _slicedToArray(_ref, 2);
          var c = _ref2[0];
          var x = _ref2[1];
          l(x, this.dataTestid, "option-".concat(c));
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }]);
}(b);
o.shadowRootOptions = _objectSpread(_objectSpread({}, b.shadowRootOptions), {}, {
  delegatesFocus: !0
});
o.styles = [$(_), w(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n            .clear-icon {\n                position: absolute;\n                right: 0.5rem;\n                top: 0.45rem;\n            }\n        "])))];
r([h({
  type: Boolean
})], o.prototype, "autocomplete", 2);
r([h({
  type: String,
  attribute: "clear-assistive-text"
})], o.prototype, "clearAssistiveText", 2);
r([h({
  type: String,
  attribute: "combobox-aria-label"
})], o.prototype, "comboboxAriaLabel", 2);
r([h({
  type: m,
  attribute: "dropdown-length"
})], o.prototype, "dropdownLength", 2);
r([v()], o.prototype, "_searchValue", 2);
o = r([f("nsc-combobox")], o);
export { m as COMBOBOX_DROPDOWN_LENGTH, o as NjcSldsCombobox };